import React, { useEffect, useState } from "react";
import { styled, Container, Box } from '@mui/material';
import { Outlet, useNavigate } from 'react-router-dom';


import Header from './header/Header';
import Sidebar from './sidebar/Sidebar';
import Label from "../../components/xaoasoft/label";
import { useDispatch, useSelector } from "react-redux";
import { Logout } from "../../redux/actions/loginauth";
// import { useSelector } from "react-redux";

const MainWrapper = styled('div')(() => ({
  display: 'flex',
  minHeight: '100vh',
  width: '100%',
}));

const PageWrapper = styled('div')(() => ({
  display: 'flex',
  flexGrow: 1,
  paddingBottom: '60px',
  flexDirection: 'column',
  zIndex: 1,
  backgroundColor: 'transparent',
}));

const FullLayout = () => {
  const [checker , setChecker] = useState();
  const naviage = useNavigate();
  const [data , setData ] = useState();
  const dispatch = useDispatch()

  // const permission = useSelector((state)=>state.login.permission)
  // useEffect(()=>{
  //   if(permission == true){
  //     setChecker(<Outlet />);
  //   }
  //   else{
  //     return naviage('/login')
  //   }
  // },[permission])

  const sessionExpired = useSelector((state) => state.Auth.sessionExpired);
    //console.log(String(sessionExpired))
  useEffect(() => {
    const loggedIn = localStorage.getItem("LoggedIn");
     if (loggedIn !== 'True' || sessionExpired) {
      localStorage.setItem("LoggedIn", 'False');
        // naviage('/login')
        // return naviage('/login')
      window.location.reload(true)
      window.location.href = "/login";
    }
    else{
      setChecker(<Outlet />);
    }
  }, [sessionExpired]);

  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const [isMobileSidebarOpen, setMobileSidebarOpen] = useState(false);
  // const lgUp = useMediaQuery((theme) => theme.breakpoints.up("lg"));

  const veri = true; //useSelector((state) => state.Auth.permission);

  useEffect(()=>{
    setData(1);
    //console.log(veri , data)
    if(data == 1){
      if(veri != true){
        naviage('/login')
      }
    }
  },[veri])

useEffect( () => {
      const loggedIn = localStorage.getItem("LoggedIn")
        if(loggedIn !== 'True'){
            localStorage.setItem("LoggedIn", 'False')
            window.location.href = "/login";
        }

    }, [])

// Set the timeout for 20 minutes
function myfunc (){
  alert('function')
  // dispatch(Logout())
}
useEffect(() => {
  const delayedLogout = () => {
    //console.log('we are calling log out here')
    // Dispatch your logout action here
    dispatch(Logout());
  };

  // Set a timeout for 20 minutes (20 minutes * 60 seconds * 1000 milliseconds)
  const timeoutId = setTimeout(delayedLogout, 120 * 60 * 1000);

  // Cleanup the timeout if the component unmounts before the timeout is reached
  return () => clearTimeout(timeoutId);
}, []);


  return (
    <MainWrapper
      className='mainwrapper'
    >
      {/* ------------------------------------------- */}
      {/* Sidebar */}
      {/* ------------------------------------------- */}
      <Sidebar isSidebarOpen={isSidebarOpen}
        isMobileSidebarOpen={isMobileSidebarOpen}
        onSidebarClose={() => setMobileSidebarOpen(false)} />
      {/* ------------------------------------------- */}
      {/* Main Wrapper */}
      {/* ------------------------------------------- */}
      <PageWrapper
        className="page-wrapper"
      >
        {/* ------------------------------------------- */}
        {/* Header */}
        {/* ------------------------------------------- */}
        <Header toggleSidebar={() => setSidebarOpen(!isSidebarOpen)} toggleMobileSidebar={() => setMobileSidebarOpen(true)} />
        {/* ------------------------------------------- */}
        {/* PageContent */}
        {/* ------------------------------------------- */}
        <Container sx={{ 
          maxWidth: '100% !important',
        }}
        >
          {/* ------------------------------------------- */}
          {/* Page Route */}
          {/* ------------------------------------------- */}
          <Box id='test1' sx={{ minHeight: 'calc(100vh - 170px)' }}>
{/*           
            {
              checker
            } */}
            {
              veri == true ?
              <Outlet />
              :
              null
            }

          </Box>
          {/* ------------------------------------------- */}
          {/* End Page */}
          {/* ------------------------------------------- */}
        </Container>
        {/* <Label /> */}
      </PageWrapper>
    </MainWrapper>
  );
};

export default FullLayout;
